export default __webpack_public_path__ + "static/media/disc_active2.4a43b386.png";